import PropTypes from 'prop-types';
import React from 'react';

export function GridLayout({
    numberOfColumns,
    customColumnRatios,
    gap = 20,
    children,
    className = ""
}) {

    let columnCss = "minmax(0, 1fr) ".repeat(numberOfColumns).trim();

    if(customColumnRatios != null){
        columnCss = customColumnRatios.map(ratio => `minmax(0, ${ratio}fr)`).join(" ");
    }

    return (
        <div className={`col-grid ${className}`} style={{ "gridTemplateColumns": columnCss, "gap": Array.isArray(gap) ? gap.map((g) => `${g}px`).join(" ") : `${gap}px` }}>
            {children}
        </div>
    );

}

GridLayout.propTypes = {
    numberOfColumns: PropTypes.number,
    customColumnRatios: PropTypes.arrayOf(PropTypes.number),
    gap: PropTypes.oneOfType([PropTypes.number, PropTypes.arrayOf(PropTypes.number)]),
    className: PropTypes.string
};